import React, { useContext, useEffect, useState, FC } from 'react';
import { documentService } from '../../../../utils/window.utils';
import Search from '../search';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import ctaTypes from '../../../../enums/CTA.enums';
import Accordion from '../../../@shared/filters/components/accordion';
import { FilterContext } from '../../fiilterContext';
import { TProductAttachmentModelFilter, TProductAttachmentSeriesFilter } from '../../types/productAttachmentSeriesWithFilter.types';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import { ALL_MODELS, ALL_SERIES } from '../../../../constants/seriesFilter.constants';
import './styles.scss';

const MobileFilter: FC<{}> = () => {
  const filters = useContext(FilterContext);
  const { model, seriesSelectedInd, modelSelectedInd, updateFilters } = filters;
  const [filtersCopy, setFiltersCopy] = useState({
    seriesSelectedIndCopy: seriesSelectedInd,
    modelSelectedIndCopy: modelSelectedInd,
  });
  const { seriesSelectedIndCopy, modelSelectedIndCopy } = filtersCopy;
  const [shouldOpenFilterModal, setShouldOpenFilterModal] = useState(false);

  useEffect(() => {
    setFiltersCopy({
      seriesSelectedIndCopy: seriesSelectedInd,
      modelSelectedIndCopy: modelSelectedInd,
    });
  }, [filters]);

  const seriesOptions: TProductAttachmentSeriesFilter[] = [
    { id: ALL_SERIES, title: <DictionaryTerm keyword="cnhi-filter-all-series" /> },
    ...model.filters,
  ];

  const modelOptions: TProductAttachmentModelFilter[] =
    seriesSelectedIndCopy === ALL_SERIES
      ? []
      : [
          {
            id: ALL_MODELS,
            title: (
              <>
                <DictionaryTerm keyword="cnhi-filter-all" /> {model.filters?.[seriesSelectedIndCopy]?.title}
              </>
            ),
          },
          ...(model.filters?.[seriesSelectedIndCopy]?.Items || []),
        ];

  const handleSeriesOptionClick = (newSeriesSelectedInd) => {
    setFiltersCopy({
      seriesSelectedIndCopy: newSeriesSelectedInd === 0 ? ALL_SERIES : newSeriesSelectedInd - 1,
      modelSelectedIndCopy: ALL_MODELS,
    });
  };

  const handleModelOptionClick = (newModelSelectedInd) => {
    setFiltersCopy({
      ...filtersCopy,
      modelSelectedIndCopy: newModelSelectedInd === 0 ? ALL_MODELS : newModelSelectedInd - 1,
    });
  };

  const toggleModal = () => setShouldOpenFilterModal(!shouldOpenFilterModal);

  const revertToOldFilters = () => {
    setFiltersCopy({ seriesSelectedIndCopy: seriesSelectedInd, modelSelectedIndCopy: modelSelectedInd });
  };

  const applyNewFilters = () => {
    updateFilters({ seriesSelectedInd: seriesSelectedIndCopy, modelSelectedInd: modelSelectedIndCopy, searchedTerm: '' });
  };

  const resetFilters = () => {
    updateFilters({ seriesSelectedInd: ALL_SERIES, modelSelectedInd: ALL_MODELS, searchedTerm: '' });
  };

  useEffect(() => {
    const docElement = documentService();
    if (!docElement?.body) return;

    if (shouldOpenFilterModal) docElement.body.classList.add('body--with-filter-model');
    else docElement.body.classList.remove('body--with-filter-model');
  }, [shouldOpenFilterModal]);

  return (
    <div className="product-attachment-series-with-filter--mbl">
      <div className="attachment-filter-modal-switch" onClick={toggleModal}>
        <Icon iconName="set-nav-services-funnel" color="primary" size={iconSize['mbl']} />
        <DictionaryTerm keyword="cnhi-filters-title" />
      </div>
      {shouldOpenFilterModal && (
        <div className="attachment-filter-modal">
          <div className="attachment-filter-modal__header">
            <span className="attachment-filter-modal__title">
              <DictionaryTerm keyword="cnhi-filters-title" />
            </span>
            <Icon
              iconName="action-close"
              color="white"
              size={iconSize['dsk']}
              onClick={() => {
                setShouldOpenFilterModal(false);
                revertToOldFilters();
              }}
            />
          </div>
          <div className="attachment-filter-modal__body">
            <Accordion
              accordionTitle={<DictionaryTerm keyword="cnhi-filters-series-title" />}
              accordionOptions={seriesOptions}
              handleOptionClick={handleSeriesOptionClick}
              selectedOptionInd={seriesSelectedIndCopy === ALL_SERIES ? 0 : seriesSelectedIndCopy + 1}
            />
            {String(modelSelectedIndCopy) && seriesSelectedIndCopy !== ALL_SERIES && (
              <Accordion
                accordionTitle={<DictionaryTerm keyword="cnhi-filters-model-title" />}
                accordionOptions={modelOptions}
                handleOptionClick={handleModelOptionClick}
                selectedOptionInd={modelSelectedIndCopy === ALL_MODELS ? 0 : modelSelectedIndCopy + 1}
              />
            )}
          </div>
          <div className="attachment-filter-modal__ctas">
            <span className={`button ${ctaTypes['primaryBlack']}`} onClick={resetFilters}>
              <DictionaryTerm keyword="cnhi-filters-reset" />
            </span>
            <span
              className={`button ${ctaTypes['primaryOrange']}`}
              onClick={() => {
                applyNewFilters();
                toggleModal();
              }}
            >
              <DictionaryTerm keyword="cnhi-filters-apply" />
            </span>
          </div>
        </div>
      )}
      <div className="attachment-filter__search">{model.shouldShowSearchBox && <Search />}</div>
    </div>
  );
};

export default MobileFilter;
